"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AuthError extends Error {
    constructor(message) {
        super(message);
        this.name = this.constructor.name;
        this.message = message;
        // Obscure typescript -> es5 transpile fix
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
exports.default = AuthError;
//# sourceMappingURL=auth_error.js.map